export default __webpack_public_path__ + "static/media/linkedin.cfe4cd5b.svg";